<template>
  <div>
    <b-form @submit="askForMainAddressAndSendForm" @reset="onReset" v-if="show">
      <b-row>
        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_name"
            class="text-left required"
            :label="$t('address_create.name_label')"
            label-for="input_name"
            :invalid-feedback="form_invalid_feedback.name"
            :state="form_state.name"
          >
            <b-form-input
              id="input_name"
              v-model.trim="form.name"
              type="text"
              required
              :state="form_state.name"
              :placeholder="$t('address_create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_country"
            class="text-left required"
            :label="$t('address_create.country_label')"
            label-for="input_country"
            :invalid-feedback="form_invalid_feedback.country"
            :state="form_state.country"
          >
            <CountrySelect
              v-model="form.country"
              :country="form.country"
              required
              :topCountry="deviceCountry"
              class="custom-select no-radius-select"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_address"
            class="text-left required"
            :label="$t('address_create.address_label')"
            label-for="input_address"
            :invalid-feedback="form_invalid_feedback.address"
            :state="form_state.address"
          >
            <b-form-input
              id="input_address"
              v-model.trim="form.address"
              type="text"
              required
              :state="form_state.address"
              :placeholder="$t('address_create.address_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_colony"
            class="text-left required"
            :label="$t('address_create.colony_label')"
            label-for="input_colony"
            :invalid-feedback="form_invalid_feedback.colony"
            :state="form_state.colony"
          >
            <b-form-input
              id="input_colony"
              v-model.trim="form.colony"
              type="text"
              required
              :state="form_state.colony"
              :placeholder="$t('address_create.colony_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_town"
            class="text-left required"
            :label="$t('address_create.town_label')"
            label-for="input_town"
            :invalid-feedback="form_invalid_feedback.town"
            :state="form_state.town"
          >
            <b-form-input
              id="input_town"
              v-model.trim="form.town"
              type="text"
              required
              :state="form_state.town"
              :placeholder="$t('address_create.town_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_federal_entity"
            class="text-left required"
            :label="$t('address_create.federal_entity_label')"
            label-for="input_federal_entity"
            :invalid-feedback="form_invalid_feedback.federal_entity"
            :state="form_state.federal_entity"
          >
            <b-form-input
              id="input_federal_entity"
              v-model.trim="form.federal_entity"
              type="text"
              required
              :state="form_state.federal_entity"
              :placeholder="$t('address_create.federal_entity_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_postal_code"
            class="text-left required"
            :label="$t('address_create.postal_code_label')"
            label-for="input_postal_code"
            :invalid-feedback="form_invalid_feedback.postal_code"
            :state="form_state.postal_code"
          >
            <b-form-input
              id="input_postal_code"
              v-model.trim="form.postal_code"
              type="text"
              required
              :state="form_state.postal_code"
              :placeholder="$t('address_create.postal_code_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <VBootstrapFormGroup
            name="group_phone"
            type="phone"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="12"
            label-cols-lg="12"
            label-cols-xl="12"
            required
            :label="$t('address_create.phone_label')"
            :invalid_feedback="form_invalid_feedback.phone"
            :state="form_state.phone"
            v-model.trim="form.phone"
          />
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_rfc"
            class="text-left"
            :label="$t('address_create.rfc_label')"
            label-for="input_rfc"
            :invalid-feedback="form_invalid_feedback.rfc"
            :state="form_state.rfc"
          >
            <b-form-input
              id="input_rfc"
              v-model.trim="form.rfc"
              type="text"
              :state="form_state.rfc"
              :placeholder="$t('address_create.rfc_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <VBootstrapFormGroup
            name="group_mobile"
            type="phone"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="12"
            label-cols-lg="12"
            label-cols-xl="12"
            required
            :label="$t('address_create.mobile_label')"
            :invalid_feedback="form_invalid_feedback.mobile"
            :state="form_state.mobile"
            v-model.trim="form.mobile"
          />
        </b-col>

        <b-col class="mt-3" cols="12" md="12">
          <b-form-checkbox id="checkbox1" v-model="form.is_main">{{ $t('address_create.main') }}</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="12" md="3">
          <b-button
            type="submit"
            variant="primary"
            size="xl"
          >{{ $t('address_create.submit_button') }}</b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-modal
      id="modalUpdateTaxAddress"
      ref="modal"
      :title="$t('address_create.update_tax_address')"
      @ok="sendForm($event, true)"
      @cancel="sendForm($event, false)"
    ></b-modal>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { CountrySelect } from "vue-country-region-select";
import VBootstrapFormGroup from "@/components/VBootstrapFormGroup";

export default {
  name: "patient-create-form",
  components: {
    CountrySelect,
    VBootstrapFormGroup,
  },
  data() {
    return {
      form: {
        name: "",
        country: "",
        address: "",
        town: "",
        colony: "",
        postal_code: "",
        federal_entity: "",
        mobile: "",
        phone: "",
        phone_extension: "",
        rfc: "",
        is_main: false,
      },
      form_invalid_feedback: {},
      form_state: {},
      show: false,
      updated: false,
      loading: true,
      patient_data: {},
      /*
      Propiedades que serán comparadas para decidir si preguntar al usuario
      si quiere copiarlas entre sus datos fiscales y su dirección principal.
      */
      properties: [
        "name",
        "country",
        "address",
        "town",
        "colony",
        "postal_code",
        "federal_entity",
        "mobile",
        "phone",
        "phone_extension",
        "rfc",
      ],
    };
  },
  computed: {
    ...mapGetters("naturalperson", [
      "getUuidPersonSelected",
      "getUuidPatientSelected",
    ]),
    ...mapGetters("auth", ["deviceCountry"]),
  },
  props: {
    a_uuid: String,
  },
  fallbackI18n: {
    messages: {
      und: {
        address_create: {
          name_label: "Address name",
          name_desc: "Address name",
          name_placeholder: "Address name",
          mobile_label: "Mobile",
          mobile_desc: "Mobile",
          mobile_placeholder: "Mobile",
          phone_label: "Phone",
          phone_desc: "Phone",
          phone_placeholder: "Phone",
          phone_extension_label: "Phone extension",
          phone_extension_desc: "Phone extension",
          phone_extension_placeholder: "Phone extension",
          identification_number_placeholder: "Identification number",
          identification_number_label: "Identification number",
          identification_number_desc: "Identification number",
          identification_type_label: "Identification type",
          identification_type_desc: "Identification type",
          identification_type_placeholder: "Identification type",
          identification_expiration_label: "Identification expiration",
          identification_expiration_desc: "Identification expiration",
          identification_expiration_placeholder: "Identification expiration",
          address_label: "Tax address",
          address_desc: "Tax address",
          address_placeholder: "Tax address",
          town_label: "Tax town",
          town_desc: "Tax town",
          town_placeholder: "Tax town",
          country_label: "Country",
          colony_label: "Tax colony",
          colony_desc: "Tax colony",
          colony_placeholder: "Tax colony",
          postal_code_label: "Tax postal code",
          postal_code_desc: "Tax postal code",
          postal_code_placeholder: "Tax postal code",
          federal_entity_label: "Tax federal entity",
          federal_entity_desc: "Tax federal entity",
          federal_entity_placeholder: "Tax federal entity",
          id_type_passport: "Passport",
          id_type_ine: "INE",
          rfc: "RFC",
          rfc_label: "RFC",
          rfc_placeholder: "RFC",
          submit_button: "Save",
          reset_button: "Reset",
          address_added: "Address added",
          main: "Main Address",
          patient_data_changed: "Patient data changed",
          update_tax_address:
            "Do you want to also update your tax address using this information?",
          error: {
            saving_patientdata: "Error saving data, check form errors.",
            retrieve_patient_data: "Cannot retrieve patient data",
            saving_address: "Error saving data, check form errors.",
          },
        },
      },
    },
  },
  watch: {
    $route() {
      if (this.a_uuid) {
        this.loadAddress();
      }
    },
    a_uuid() {
      this.reset_form();
      if (this.a_uuid) {
        this.loadAddress();
      }
    },
  },
  created() {
    if (this.a_uuid) {
      this.loadAddress();
    } else {
      this.show = true;
    }
  },
  methods: {
    loadAddress() {
      this.$store
        .dispatch("naturalperson/GET_ADDRESS", {
          a_uuid: this.a_uuid,
          pt_uuid: this.getUuidPatientSelected,
        })
        .then(
          (response) => {
            var address = response.data;
            if (address) {
              this.form = address;
              this.a_uuid = address.uuid;
              this.updated = true;
            }
            this.show = true;
          },
          () => {
            this.$router.push({ name: "not_found" });
          }
        );
      this.loadPatientData();
    },
    loadPatientData: function () {
      this.$store
        .dispatch("naturalperson/GET_PATIENT", {
          pt_uuid: this.getUuidPatientSelected,
        })
        .then(
          (response) => {
            var patient = response.data;
            if (patient) {
              this.patient_data = patient;
            }
          },
          (e) => {
            this.$sentry({ capture: e });
            this.mnotify_error({
              text: this.$t("address_create.error.retrieve_patient_data"),
            });
          }
        );
    },
    updatePatient(data) {
      if (data.is_main) {
        for (var i = 0; i < this.properties.length; i += 1) {
          this.patient_data[this.properties[i]] = data[this.properties[i]];
        }
        var url = "naturalperson/PATCH_PATIENT";
        var data_send = {
          data: this.patient_data,
          pt_uuid: this.patient_data.uuid,
        };
        return this.$store.dispatch(url, data_send).then(
          (response) => {
            var patient_data = response.data;
            if (patient_data) {
              this.patient_data = patient_data;
            }
            this.mnotify({
              text: this.$t("address_create.patient_data_changed"),
            });
          },
          (err) => {
            this.showResponseError(err);
            this.putFormFeedback(err.response);
            this.mnotify_error({
              text: this.$t("address_create.error.saving_patientdata"),
            });
          }
        );
      }
    },
    showModal() {
      this.$refs["modal"].show();
    },
    compareAdrress() {
      var data = this.form;
      for (var i = 0; i < this.properties.length; i += 1) {
        if (
          this.patient_data &&
          this.patient_data[this.properties[i]] != data[this.properties[i]]
        ) {
          return false;
        }
      }
      return true;
    },
    sendForm(evt, update_patient_data) {
      evt.preventDefault();

      var pt_uuid =
        this.$route.params.pt_uuid != undefined
          ? this.$route.params.pt_uuid
          : this.getUuidPatientSelected;

      var data = this.form;
      data.person = this.getUuidPersonSelected;
      var url = "naturalperson/NEW_ADDRESS";
      var data_send = {
        data: data,
        pt_uuid: pt_uuid,
      };

      if (this.updated) {
        url = "naturalperson/PATCH_ADDRESS";
        data_send = {
          data: data,
          a_uuid: this.a_uuid,
          pt_uuid: pt_uuid,
        };
      }

      var address;
      this.$store
        .dispatch(url, data_send)
        .then((response) => {
          address = response.data;
          if (update_patient_data) {
            return this.updatePatient(this.form);
          }
        })
        .then(
          () => {
            address.pt_uuid = pt_uuid;
            this.$emit("address-new-updated", address);
          },
          (err) => {
            this.showResponseError(err);
            this.putFormFeedback(err.response);
            this.mnotify_error({
              text: this.$t("address_create.error.saving_address"),
            });
          }
        );
    },
    askForMainAddressAndSendForm(evt) {
      evt.preventDefault();
      if (!this.compareAdrress() && this.form.is_main) {
        // Este modal llamará a sendForm()
        this.showModal();
      } else {
        this.sendForm(evt, false);
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.reset_form();
    },
    reset_form() {
      /* Reset our form values */
      for (var prop in this.form) {
        if (this.form.hasOwnProperty(prop)) {
          delete this.form[prop];
        }
      }
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>
